import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/$ajax.js'
import createLogger from 'vuex/dist/logger'
Vue.use(Vuex);
var vue = new Vue();
const state = {
	itemAllSite: [],
	id: 1,
	curOrder: null,
	delayed: 'index',
	width: '990px',
	hasTipsBorder: false,
	footer: {
		isFooter: false,
		isEdit: false,
		isShow: false,
		tName: "footerNav",
		itemNav: [],
		iconNav: "https://diy.xiaohucloud.cn/static/image/footer_icon.png",
		navStyle: {},
		iStyle: {}
	},
	flag: true,
	router: {
		id: "phoneRouter",
		hoverStyle: {},
		isLanguage: false,
		langugeQx: {
			tName: "mltilingual",
			tText: '多语言',
			isShow: true,
			isEdit: false,
			parent: true,
			styleType: 2,
			setnumber: 1,
			domain: "",
			curMltilingual: "中文",
			mClass: "topGrade",
			parentStyle: {
				left: 0,
				top: 0,
				position: "absolute",
				zIndex: 0,
				width: 60,
				height: 300
			},
			setFontStyle: {
				color: '#333',
				fontSize: '14px',
				backgroundColor: '#fff',
				lineHeight: '50px'
			},
			setDivStyle: {
				textAlign: 'left'
			}
		}
	},
	isBackStyle: true,
	phoneNav: {
		tName: "PhoneNav",
		tText: '手机导航',
		isEdit: false,
		id: "phoneNav",
		isBackStyle: true,
		isShow: false,
		draging: false,
		isShowUp: false,
		isShowDown: false,
		mClass: "Typesetting",
		diesc: "",
		mImage: {
			url: "",
		},
		zinStyle: {
			zIndex: 0
		},
		conStyle: {
			paddingTop: '0',
			paddingLeft: '0',
			paddingRight: '0',
			paddingBottom: '0',
			borderWidth: "0",
			height: "120px"
		},
		navheader: {
			mStyle: 1,
			url: "https://diy.xiaohucloud.com/static/image/search_icon.png",
			fontSize: '14px',
			curBackground: "",
			curFont: "",
			color: '#fff',
			height: '60px',
			background: '#409EFF'
		},
		logoStyle: {
			textAlign: 'left'
		},
		iconStyle: {
			textAlign: 'right'
		},
		backStyle: {
			display: 'none',
			color: '#ffffff',
			marginTop: '0px',
			fontSize: '20px'
		},
		navheaderImg: {
			width: '100%'
		},
		namenumber: '1',
		mainText: {
			web_name: '',
			web_logo: '',
			web_icon: ''
		},
		itemInner: [],
		aloneIcon: "panelModuleIcon_pack moduleArea_pack",
		aloneText: "moduleAloneText"
	},
	itemCon: {}
}

const mutations = {
	setState(state, data) {
		state.itemAllSite = data.itemAllSite; //
		state.delayed = data.delayed; //
		state.footer = data.footer || {
			isFooter: false,
			isEdit: false,
			isShow: false,
			tName: "footerNav",
			itemNav: [],
			iconNav: "https://diy.xiaohucloud.com/static/image/footer_icon.png",
			navStyle: {},
			iStyle: {}
		}; //
		state.router = data.router; //
		state.phoneNav = data.phoneNav; //
		state.itemCon = data.itemCon; //
		state.width = data.width; //
	},
	setAllSite(state, allSite) {
		state.itemAllSite.splice(0, state.itemAllSite.length);
		for(var i = 0; allSite.length > i; i++) {
			state.itemAllSite.push($.extend(true, allSite[i], {}));
		}
	},
	setOrderId(state, id) {
		state.id = id; //
	},
	setDelayed(state, id) {
		state.delayed = id; //
	},
	mFooter(state, obj) {
		if(obj.itemNav) {
			state.footer.itemNav = obj.itemNav; //
		}
		state.footer.isShow = obj.isShow; //
	},
	orderbyId(state) {
		if(!state.itemCon) {
			state.itemCon = {};
			state.itemCon[state.delayed] = {};
			state.itemCon[state.delayed].stream = [];
		} else if(!state.itemCon[state.delayed]) {
			state.itemCon[state.delayed] = {};
			state.itemCon[state.delayed].stream = [];
		};
		var stream = state.itemCon[state.delayed].stream;
		var isNav = {
			zinStyle: {}
		};
		stream = stream.map((obj, index) => {
			obj.order = index + 1;
			obj.zinStyle.zIndex = index + 1;
			if(obj.itemInner && obj.itemInner.length) {
				for(var i = 0; obj.itemInner.length > i; i++) {
					var flagItem = obj.itemInner[i];
					if(flagItem.tName == "moduleAreaNav") {
						isNav = obj;
						return;
					}
				}
			} else if(obj.labelTitle && obj.labelTitle.length) {
				for(var h = 0; h < obj.labelTitle.length; h++) {
					var lblinner = obj.labelTitle[h].itemInner;
					if(lblinner) {
						for(let k = 0; lblinner.length > k; k++) {
							var flagItem = lblinner[k];
						}
					}
				}
			}
			isNav.zinStyle.zIndex = 10;
			return obj;
		});

	},
	change(state, k) { //交换数组的位置
		var arr = state.itemCon[state.delayed].stream;
		arr[k.k].isShow = false;
		arr[k.j].isShow = false;
		var tempOption = arr[k.j];
		Vue.set(arr, k.j, arr[k.k]);
		Vue.set(arr, k.k, tempOption);
		setTimeout(function() {
			arr[k.k].isShow = true;
			arr[k.j].isShow = true;
		}, 1);
	},
	addProps(state, props) { //新增属性
		Vue.set(state.itemCon, props, {
			stream: [],
			artD: [],
			posCom: []
		});
	},
	pushItemStream(state, item) { //新增容器模块
		state.itemCon[state.delayed].stream.push(item); //追加组件
	},
	delItemStream(state, item) { //删除组件（标准模块）
		var stream = state.itemCon[state.delayed].stream;
		for(let j = 0; stream.length > j; j++) {
			var itemInner = stream[j].itemInner;
			var labelTitle = stream[j].labelTitle;
			var itemInner1 = stream[j].itemInner1;
			var itemInner2 = stream[j].itemInner2;

			if(itemInner && itemInner.length && itemInner.indexOf(item) != -1) {
				var dd = itemInner.splice(itemInner.indexOf(item), 1);
				stream[j].isShow = false;
				setTimeout(function() {
					stream[j].isShow = true;
					stream[j].isStopPropagation = false;
				}, 10);
			} else if(labelTitle) {
				for(let i = 0; labelTitle.length > i; i++) {
					var itemInner2 = labelTitle[i].itemInner;
					if(itemInner2 && itemInner2.length && itemInner2.indexOf(item) != -1) {
						itemInner2.splice(itemInner2.indexOf(item), 1);
					}
					if(labelTitle[i].curObj && labelTitle[i].curObj.item == 1) {
						var itemInner = labelTitle[i].itemInner;
						// itemInner.splice(itemInner.indexOf(item), 1);
						for(let r = 0; itemInner.length > r; r++) {
							if(itemInner[r].allId == item.allId) {
								itemInner.splice(r, 1);
								break;
							}
						}
						//debugger;
						//break;
					} else if(labelTitle[i].curObj && labelTitle[i].curObj.item == 2) {
						var columnTitle1 = labelTitle[i].columnTitle1;
						for(let j = 0; columnTitle1.length > j; j++) {
							var itemInner = columnTitle1[j].itemInner;
							//
							for(let g = 0; itemInner.length > g; g++) {
								if(itemInner[g].allId == item.allId) {
									//delete itemInner[g];
									itemInner.splice(g, 1);
									break;
								}
							}
							//debugger;
							//break;
						}
					}

					stream[j].isShow = false;
					setTimeout(function() {
						stream[j].isShow = true;
					}, 10);
				}
			} else if(itemInner1 && itemInner1.length && itemInner1.indexOf(item) != -1) {
				itemInner1.splice(itemInner1.indexOf(item), 1);
				stream[j].isShow = false;
				setTimeout(function() {
					stream[j].isShow = true;
				}, 10);
			} else if(itemInner2 && itemInner2.length && itemInner2.indexOf(item) != -1) {
				itemInner2.splice(itemInner2.indexOf(item), 1);
				stream[j].isShow = false;
				setTimeout(function() {
					stream[j].isShow = true;
				}, 10);
			}

		}
	},
	delItemPos(state, item) { //删除组件（全屏模块）
		let posCom = state.itemCon[state.delayed].posCom;
		let artD = state.itemCon[state.delayed].artD;
		if(posCom.length) {
			for(let j = 0; posCom.length > j; j++) {
				if(posCom.indexOf(item) != -1) {
					posCom.splice(posCom.indexOf(item), 1);
				}
			}
		}
		if(artD.length) {
			for(let j = 0; artD.length > j; j++) {
				if(artD[j].itemInner.indexOf(item) != -1) {
					artD[j].itemInner.splice(artD[j].itemInner.indexOf(item), 1);
				}
			}
		}
	},
	delItemArtD(state, item) { //删除组件（弹窗）
		let artD = state.itemCon[state.delayed].artD;
		if(artD.length) {
			if(artD.indexOf(item) != -1) {
				artD.splice(artD.indexOf(item), 1);
			}
		}
	},
	pushItemStreamItem(state, it) { //新增内容模块
		var i = state.itemCon[state.delayed].stream.indexOf(it.i); //
		if(state.itemCon[state.delayed].stream[i].itemInner) {
			state.itemCon[state.delayed].stream[i].itemInner.push(it.item); //追加组件
		} else if(state.itemCon[state.delayed].stream[i].itemInner1) {
			state.itemCon[state.delayed].stream[i].itemInner1.push(it.item);
		} else if(state.itemCon[state.delayed].stream[i].itemInner2) {
			state.itemCon[state.delayed].stream[i].itemInner2.push(it.item);
		}
		state.curOrder = {}; //正在的拖动组件（临时保存）
	},
	pushItemPosCom(state, item) {  // 新增组件（标准模块）
		state.itemCon[state.delayed].posCom.push(item); //
	},
	pushItemArtCom(state, item) { // 新增组件（弹窗模块）
		state.itemCon[state.delayed].artD[item.i].itemInner.push(item.item); //
	},
	pushItemArtD(state, item) {
		state.itemCon[state.delayed].artD.push(item); //
	},
	delStreamModule(state, obj) {// 新增弹窗模块
		var stream = state.itemCon[state.delayed].stream;
		var j = stream.indexOf(obj.order);
		stream.splice(j, 1);
		if(stream[j]) {
			stream[j].isShow = false;
			setTimeout(function() {
				stream[j].isShow = true;
			}, 10);
		}
	},
	getAllLocalData(state, item) {// 获取本地数据
		var allSite = JSON.parse(localStorage.getItem(item.version_id + "000")) || [];

		if(!state.itemCon[state.delayed]) {
			Vue.set(state.itemCon, state.delayed, {
				stream: [],
				artD: [],
				posCom: []
			});
		}
console.log(Array.isArray(allSite))
		if(Array.isArray(allSite) && !allSite.length) {
     
			api.get('/api/diy/getTemplateVersionByColumnId?template_id=' + item.id + '&token=' + item.token + "&version_id=" + item
				.version_id + "&column_id=" + item.version_id + "000" + "&type=" + item.type, false, {},
				function(r) {
					if(!r) {
						// return;
					}

          console.log(state.footer)

					if(r.data.content) {

						allSite = JSON.parse(r.data.content);

						state.router = allSite.router;
						state.phoneNav = allSite.phoneNav;
						if(allSite.footer.isShow) {
							state.footer = allSite.footer;
						}

						state.itemCon = allSite.itemCon;
						//debugger;
						if(allSite) {
							localStorage.setItem(item.version_id + "000", JSON.stringify(allSite));
						}
					}
				});
			//allSite = JSON.parse(localStorage.getItem(item.version_id + "000")) || [];

			return;
		} else if(!Array.isArray(allSite)) {
			state.router = allSite.router;
			state.phoneNav = allSite.phoneNav;
			if(allSite.footer && allSite.footer.isShow) {
				state.footer = allSite.footer;
			}
			state.itemCon = allSite.itemCon;
		}
		//debugger;
		if(allSite && allSite.length) {
			for(var i = 0; allSite.length > i; i++) {
				state.itemCon[state.delayed].stream.push(allSite[i]);
			}
		}

	},
	setItemSite(state, item) { // 设置全局模块

		var index = state.itemCon[state.delayed].stream.indexOf(item.order);
		var allSite = {
			itemCon: {}
		};
		var itemObj = state.itemCon[state.delayed].stream[index];
		try {
			var aSite = JSON.parse(localStorage.getItem(item.version_id + "000"));
			var itemAllSite = aSite.itemCon[item.version_id + "000"].stream;
			// debugger
			if(itemAllSite) {
				var isAllSite = true; //全站模块（临时保存）

				for(var i = 0; itemAllSite.length > i; i++) {
					if(itemAllSite[i].allId && itemObj.allId == itemAllSite[i].allId) {
						itemAllSite[i] = itemObj;
						isAllSite = false;
						localStorage.setItem(item.version_id + "000", JSON.stringify(aSite));
					}
				}
			}
			if(isAllSite) {
				//debugger;
				itemObj.allId = itemObj.allId || item.guid;
				state.itemAllSite.push(itemObj);
				aSite.itemCon[item.version_id + "000"].stream.push(itemObj);
				localStorage.setItem(item.version_id + "000", JSON.stringify(aSite));
			}
		} catch(e) {
			Vue.set(allSite.itemCon, item.version_id + "000", {
				stream: [],
				artD: [],
				posCom: []
			});
			//debugger
			allSite.itemCon[item.version_id + "000"].stream.push(itemObj);
			localStorage.setItem(item.version_id + "000", JSON.stringify(allSite));
		}

	},
	getAllSite(state, item) { // 获取全局模块的数据
		var allSite = JSON.parse(localStorage.getItem(item.version_id + "000"));
		if(!state.itemCon || !state.itemCon[state.delayed] || !state.itemCon[state.delayed].stream) {
			Vue.set(state.itemCon, state.delayed, {
				stream: [],
				artD: [],
				posCom: []
			});
		}
		if(!allSite || allSite == null) {
			return;
		}

		if(allSite.router && allSite.router.isAllSite) {
			state.router = allSite.router;
			if(state.phoneNav.isBackStyle) {
				state.phoneNav = allSite.phoneNav;
			} else {
				state.phoneNav.zinStyle = allSite.phoneNav.zinStyle;
				state.phoneNav.mImage = allSite.phoneNav.mImage;
				state.phoneNav.conStyle = allSite.phoneNav.conStyle;
				state.phoneNav.navheader = allSite.phoneNav.navheader;
				state.phoneNav.logoStyle = allSite.phoneNav.logoStyle;
				state.phoneNav.navheaderImg = allSite.phoneNav.navheaderImg;
				state.phoneNav.namenumber = allSite.phoneNav.namenumber;
				state.phoneNav.mainText = allSite.phoneNav.mainText;
				state.phoneNav.iconStyle = allSite.phoneNav.iconStyle;
			}
		}
		if(allSite.footer&&allSite.footer.isShow) {
			state.footer = allSite.footer;
		}
		var stream = [];
		if(state.itemCon[state.delayed]) {
			stream = state.itemCon[state.delayed].stream;
		} else {
			Vue.set(state.itemCon, state.delayed, {
				stream: [],
				artD: [],
				posCom: []
			});
		}

		if(Array.isArray(allSite)) {
			state.itemAllSite = allSite || [];
		} else if(allSite.itemCon) {
			state.itemAllSite = allSite.itemCon[item.version_id + "000"] && allSite.itemCon[item.version_id + "000"].stream;
		}

		if(state.itemAllSite && state.itemAllSite.length) {
			for(var i = 0; state.itemAllSite.length > i; i++) {
				var emSite = state.itemAllSite[i];
				emSite.mAllFlag = true;
				var flag = true;
				if(stream) {
					for(let j = 0; stream.length > j; j++) {
						stream[j].mAllFlag = false;
						if(stream[j].allId && emSite.allId == stream[j].allId) {
							stream[j] = emSite;
							flag = false;
						}
					}
				}
				if(flag) {
					stream.push(emSite);
				}
			}
			state.itemCon[state.delayed].stream = stream;
			if(allSite.itemCon) {
				let curPos = state.itemCon[state.delayed].posCom;
				let curArtD = state.itemCon[state.delayed].artD;
				let pos = allSite.itemCon[item.version_id + "000"].posCom;
				let artD = allSite.itemCon[item.version_id + "000"].artD || [];
				//pos.mAllFlag = true;
				//artD.mAllFlag = true;
				for(let j = 0; pos.length > j; j++) {
					let dgFlag = true;
					pos[j].mAllFlag = true;
					for(let k = 0; curPos.length > k; k++) {
						if(pos[j].allId == curPos[k].allId) {
							pos[j] = curPos[k];
							dgFlag = false;
						}
					}
					if(dgFlag) {
						curPos.push(pos[j]);
					}
				}
				for(let j = 0; artD.length > j; j++) {
					let dgFlag = true;
					artD[j].mAllFlag = true;
					for(let k = 0; curArtD.length > k; k++) {
						if(artD[j].allId == curArtD[k].allId) {
							artD[j] = curArtD[k];
							dgFlag = false;
						}
					}
					if(dgFlag) {
						curArtD.push(artD[j]);
					}
				}
			}
		}
	},
	setAllStyle(state, item) { //全站模块（临时保存）

		var isAllSite = true;
		var allState = {};
		state.router.isAllSite = true;
		allState.itemAllSite = state.itemAllSite;
		allState.router = state.router;
		allState.phoneNav = state.phoneNav;
		localStorage.setItem(item.version_id + "000", JSON.stringify(allState));
	},
	copyModule(state, obj) {//复制模块
		obj.order.allId = "m" + vue.$utils.GenNonDuplicateID();
		state.itemCon[state.delayed].stream.splice(obj.index, 0, obj.order); //
	},
	setPosSite(state, item) { //
		if(!(state.itemAllSite && state.itemAllSite.indexOf(item.order) != -1)) {
			item.order.isAllSite = true;
			var flag = true;
			item.order.allOrder = item.order.allOrder || state.itemAllSite.length + 1;
			for(var i = 0; state.itemAllSite.length > i; i++) {
				if(item.order.allOrder == state.itemAllSite[i].allOrder) {
					item.order.isShow = true;
					state.itemAllSite[i] = item.order;
					flag = false;
					break;
				}
			}

			if(flag) {
				state.itemAllSite.push(item.order); // 全站模块（临时保存）
			}

			localStorage.setItem(item.id + item.type + "itemAllSite", JSON.stringify(state.itemAllSite));
		}
	},
	setCurOrder(state, order) {
		state.curOrder = order; //正在的拖动组件（临时保存）
	}
}
const getters = {
	state: function(state) {
		return state
	},
	itemCon(state) {
		return state.itemCon
	},
	getDataCur(state) {  //获取当前页面的数据

		state.itemCon = state.itemCon || {};
		if(state.itemCon && !state.itemCon[state.delayed]) {
			Vue.set(state.itemCon, state.delayed, {
				stream: [],
				artD: [],
				posCom: []
			});
		}
		for(let j = 0; j < state.itemCon[state.delayed].stream.length; j++) {

			state.itemCon[state.delayed].stream[j].allId = state.itemCon[state.delayed].stream[j].allId || "m" + vue.$utils.GenNonDuplicateID();
		}
		//debugger
		state.itemCon[state.delayed].artD = state.itemCon[state.delayed].artD || [];
		return state.itemCon[state.delayed];
	},
	router: function(state) { //网站底部路径
		state.router = state.router || {};
		state.router.id = state.router.id || "phoneRouter";
		state.router.hoverStyle = state.router.hoverStyle || {}
		// debugger;
		state.router.langugeQx = state.router.langugeQx || {
			tName: "mltilingual",
			tText: '多语言',
			isShow: true,
			isEdit: false,
			parent: true,
			styleType: 1,
			setnumber: 1,
			domain: "",
			curMltilingual: "中文",
			mClass: "topGrade",
			parentStyle: {
				left: 0,
				top: 0,
				position: "absolute",
				zIndex: 0,
				width: 60,
				height: 300
			},
			setFontStyle: {
				color: '#333',
				fontSize: '14px',
				backgroundColor: '#fff',
				lineHeight: '50px'
			},
			setDivStyle: {
				textAlign: 'left'
			}
		};

		return state.router
	},
	footerNav: function(state) {
		//state.footerNav = state.footerNav || "phoneNav";
		//debugger;
		return state.footer
	},
	phoneNav: function(state) {
		state.router = state.router || {
			navheader: {}
		};
		state.phoneNav = state.phoneNav || {
			tName: "PhoneNav",
			tText: '手机导航',
			isEdit: false,
			id: "phoneNav",
			isBackStyle: true,
			isShow: false,
			draging: false,
			isShowUp: false,

			isShowDown: false,
			mClass: "Typesetting",
			diesc: "",
			mImage: {
				url: "",
			},
			zinStyle: {
				zIndex: 0
			},
			conStyle: {
				paddingTop: '0',
				paddingLeft: '0',
				paddingRight: '0',
				paddingBottom: '0',
				borderWidth: "0",
				height: "120px"
			},
			navheader: {
				mStyle: 1,
				url: "https://diy.xiaohucloud.com/static/image/search_icon.png",
				fontSize: '14px',
				curBackground: "",
				curFont: "",
				color: '#fff',
				height: '60px',
				background: '#409EFF'
			},
			logoStyle: {
				textAlign: 'left'
			},
			iconStyle: {
				textAlign: 'right'
			},
			backStyle: {
				display: 'none',
				color: '#ffffff',
				marginTop: '0px',
				fontSize: '20px'
			},
			navheaderImg: {
				width: '100%'
			},
			namenumber: '1',
			mainText: {
				web_name: '',
				web_logo: '',
				web_icon: ''
			},
			itemInner: [],
			aloneIcon: "panelModuleIcon_pack moduleArea_pack",
			aloneText: "moduleAloneText",
		};
		//state.phoneNav.navheader = state.phoneNav.navheader || {};
		state.phoneNav.mainText = state.phoneNav.mainText || {};
		//state.phoneNav.navheader.mStyle = state.phoneNav.navheader.mStyle || 1
		//debugger
		return state.phoneNav
	}
}
const actions = {
	saveData(context, obj) {

		context.commit('setOrderId', obj.id);
		var objdata = {
			template_id: obj.id,
			token: obj.token,
			html: obj.html || "",
			column_id: obj.param,
			version_id: obj.version_id,
			type: obj.type,
			content: JSON.stringify(state)
		};
		// debugger
		api.post('/api/diy/saveTemplateVersionWithColumnId', true, objdata, function(r) {
			if(r.data.version_id) {
				vue.$msg("生成页面完成");
				$("#loadGit").hide();
			} else if(r.data.result_msg) {
				vue.$msg(r.data.result_msg);
			}
      console.log(obj.param)
			localStorage.removeItem(obj.param);
		});
	},
	saveloca(context, obj) { //设置本地的数据
		for(let key in state.itemCon) {
			if(key != state.delayed) {
				state.itemCon[key] = {
					stream: [],
					artD: [],
					posCom: []
				};
			}
		}
		localStorage.setItem(obj.param, JSON.stringify(state));
	},
	getData(context, obj) {//获取页面数据
		// debugger
		var state = JSON.parse(localStorage.getItem(obj.param));
		var allSite = JSON.parse(localStorage.getItem(obj.version_id + "000"));
		if(!allSite) {
			api.get('/api/diy/getTemplateVersionByColumnId?template_id=' + obj.id + '&token=' + obj.token + "&version_id=" + obj
				.version_id + "&column_id=" + obj.version_id + "000" + "&type=" + obj.type, false, {},
				function(r) {
					if(!r) {
						//return;
					}
					if(r.data.content) {
						allSite = JSON.parse(r.data.content);
						if(allSite) {
							localStorage.setItem(obj.version_id + "000", JSON.stringify(allSite));

						}
					}
				});
		}

		if(!state) {
			api.get('/api/diy/getTemplateVersionByColumnId?template_id=' + obj.id + '&token=' + obj.token + "&version_id=" +
				obj.version_id + "&column_id=" + obj.param + "&type=" + obj.type, false, {},
				function(r) {
					if(!r) {
						return;
					}
					if(r.data.content) {
						if(r.data.content.indexOf(obj.param) == -1) {
							var state = JSON.parse(r.data.content.replace(/index/g, obj.param));
						} else {
							var state = JSON.parse(r.data.content);
						}

						// var state = JSON.parse(r.data.content.replace(/index/g,obj.param));
						//debugger
						if(state) {
							context.commit('setState', state);
						}
					}
					return;
				});
		}
		state && context.commit('setState', state);
	}
}

export default new Vuex.Store({
	state,
	actions,
	getters,
	plugins: [createLogger()],
	mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js